import * as Icon from "react-feather";
import { useSelector } from "react-redux";
import { Link } from "react-router";

import SyntaxHighlighter from "react-syntax-highlighter";
import { atelierLakesideDark as codeStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";

import Page from "../common/Page";
import Card from "../common/Card";

import { useTranslation } from "react-i18next";
import { capitalizeFirst, upperCase } from "../../utils/manipulateText";
import styled from "styled-components";
import LanguageSelector from "../common/LanguageSelector";
import Loading from "../common/Loading";
import UserSelector from "../common/UserSelector";

const StyledSyntaxHighlighter = styled(SyntaxHighlighter)`
  max-height: 400px;
`;

const AppAdsTxt = () => {
  const { t, i18n } = useTranslation();
  const selectedUser = useSelector((state) => state?.site?.selectedUser);
  const selectedUserLoading = useSelector(
    (state) => state.site?.selectedUserLoading
  );

  return (
    <Page
      title={
        <>
          <div className={"flex justify-between items-center"}>
            <UserSelector />

            <LanguageSelector customStyle="ml-auto" />
          </div>
        </>
      }
    >
      <div className="flex">
        <div className="w-full mr-4">
          <Card>
            <span className="sm:inline-flex p-1 border bg-gray-200 rounded-md mx-4 mt-4">
              {!selectedUser?.isApp && (
                <Link
                  to="/settings"
                  className="transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded"
                  data-tagcontent="0"
                >
                  {upperCase(t("ad integration"))}
                </Link>
              )}{" "}
              <Link
                to="/settings/adstxt"
                className="transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded bg-white shadow-md"
                data-tagcontent="1"
              >
                ADS.TXT
              </Link>
            </span>
            <Card.Body>
              {selectedUserLoading ? (
                <Loading />
              ) : (
                <>
                  {i18n.language === "en" && (
                    <p className="text-xs text-gray-600">
                      You need to set up an Ads.txt file to list Empower's
                      authorized selling seas on the ad exchanges to help
                      prevent ad fraud. The Ads.txt lines will help you to
                      prevent your site from two main types of problems–
                      unauthorized reselling of your ad inventory through
                      arbitration, and more importantly, ad fraud through
                      misrepresentation or counterfeit ad impressions.
                    </p>
                  )}
                  <p className="text-xs text-gray-600 mt-2">
                    {t(
                      "Here are your site's specific ads.txt lines. You can download it from the button below that says Download Ads.txt. You'll need to take this file and upload it to the root directory of your site so it's accessible when you visit this page of your site"
                    )}
                    <span>: domain.com</span>
                  </p>
                  <p className="text-xs text-gray-600 mt-2 mb-4">
                    {t(
                      "You may need to get FTP access in order to upload a file to your root directory, so please check with your hosting company or your CMS's support portal."
                    )}
                  </p>
                  <a
                    className="bg-white border border-gray-100 shadow-md px-3 py-1 inline-flex justify-center rounded-lg text-xs mr-3 mb-4 group hover:bg-empower-500 hover:text-white"
                    href="/ads.txt"
                    target="_blank"
                  >
                    <Icon.Download
                      className="cursor-pointer text-gray-600 group-hover:text-white mr-2"
                      width="16"
                      height="16"
                    />
                    {capitalizeFirst(t("download ads.txt file"))}
                  </a>
                  <StyledSyntaxHighlighter
                    language="xml"
                    style={codeStyle}
                    useInlineStyles="true"
                  >
                    {selectedUser?.adsTxt?.join("\n")}
                  </StyledSyntaxHighlighter>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </Page>
  );
};

export default AppAdsTxt;
